import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { btnPrimary, btnSecondary } from "@/components/site/buttons";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" noindex />
      <section className="mx-auto flex min-h-[70vh] max-w-2xl flex-col items-center justify-center px-5 text-center">
        <span className="font-serif text-[8rem] font-light leading-none text-gold-500/30">404</span>
        <h1 className="mt-4 font-serif text-4xl font-light text-ink">This page could not be found</h1>
        <p className="mt-4 font-sans leading-relaxed text-steel-600">
          The page you’re looking for may have moved or no longer exists.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/" className={btnPrimary}>Return home</Link>
          <Link to="/articles" className={btnSecondary}>Browse articles</Link>
        </div>
      </section>
    </>
  );
}
